'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { fetch } from 'DesignData/actions/CustomWidgetBuffers';
import CustomWidgetEditor from './CustomWidgetEditor';
const mapDispatchToProps = {
  fetchCustomWidgetBuffer: fetch
};

function CustomWidgetEditorByIdContainer(props) {
  return /*#__PURE__*/_jsx(CustomWidgetEditor, Object.assign({}, props));
}

export default connect(null, mapDispatchToProps)(CustomWidgetEditorByIdContainer);